export class Player {
 id: number;
 title: string;
 album: string;
 albumid: number;
 artist: string;
 mediaType: string;
 mediaUrl: string;
 graphic: string;
 continous: number;
 secureMediaUrl: any;
}



// WEBPACK FOOTER //
// ./src/models/player.model.ts